<form class="move-payment-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'INVOICE.PAYMENT.MOVE_TO_BALANCE' | translate }}</h4>
  <app-information-block [text]="'INVOICE.PAYMENT.MOVE_TO_BALANCE_DESCRIPTION' | translate"></app-information-block>

  <section class="astral-section-surface astral-section-surface--compact astral-form-stack">
    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
      <div class="astral-layout-item">
        <app-autocomplete-remote [control]="form.controls['contactId']" [service]="filterService"></app-autocomplete-remote>
      </div>
      <app-money-box [control]="form.controls['amount']"></app-money-box>
    </astral-layout-group>
    <astral-input [control]="form.controls['verificationDescription']"></astral-input>
  </section>

  <div class="astral-form-actions">
    <astral-button variant="primary" type="submit" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
